import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";

export default class ClientSuiteInput extends React.Component {
  state = {
    options: []
  };

  fetchData = search => {
    const { company_id } = this.props;
    return fetchJson("/products/client_suites.json", { company_id, search }).then(records => {
      var options = records.map(m => ({ label: m.name, value: m.id }));
      this.setState({ options });
      return options;
    });
  };

  render() {
    const { onChange, multiple, value } = this.props;
    const { options } = this.state;
    const selectedValue = value ? options.filter(o => o.value == value) : undefined;
    return (
      <AsyncSelect
        value={selectedValue}
        placeholder={multiple ? "Pick Client Suites" : "Pick Client Suite"}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={customStyles()}
        id="suite_id"
        loadOptions={this.fetchData}
        defaultOptions={true}
        onChange={onChange}
        isClearable={true}
      />
    );
  }
}
